import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import SunCustomersForm from "../../../components/forms/setup/sunCustomers/SunCustomersForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function SunCustomersViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [sunCustomers, setSunCustomers] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getSunCustomersForDropdown = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`sunCustomers`, payload);
    setLoading(false);
    if (callResult.success) {
      setSunCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createSunCustomer = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createSunSunCustomer", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "SUN Customeradded",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunCustomersForDropdown("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateSunCustomer = async function (sunCustomer, values, index) {
    const payload = { ...values, id: sunCustomer.id };
    let callResult = await makePutApiCall(`sunCustomers/${sunCustomer.id}`, payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "SUN Customer updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunCustomersForDropdown("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddSunCustomerSlideOver = () => {
    setSlideOver({
      childComponent: (
        <SunCustomersForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createSunCustomer}
        />
      ),
      open: true,
    });
  };

  const viewSunCustomerDetails = async function (sunCustomer, index) {
    setSlideOver({
      childComponent: (
        <SunCustomersForm
          sunCustomer={sunCustomer}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateSunCustomer}
        />
      ),
      open: true,
    });
  };

  const deleteSunCustomer = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSunSunCustomer/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSunCustomersForDropdown("", 1);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message || "SUN Customer deleted",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteSunCustomer = function (sunCustomer, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteSunCustomer(sunCustomer.id, index)}
          message={`Are you sure you want to delete ${sunCustomer.location}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteSunCustomer,
    emptyModal,
    getSunCustomersForDropdown,
    loading,
    sunCustomers,
    openAddSunCustomerSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewSunCustomerDetails,
  };
}

